import { createSelector } from 'reselect'
import enums from '../../../constants/enums';
import { getSavedViewData, saveViewedData } from './Trades.helper';

const ownProps = (state, ownProps) => ownProps;

const getTrades = createSelector(
  state => state.trades.trades,
  state => state.trades.expanded,
  (trades, expanded) => {
    if (!trades) {
      return trades;
    }
    return trades
      .map(trade => {
        const giftCardType = enums.giftcards.find(card => card.value === trade.payment_method_name);
        let presetMessages = [];
        if (giftCardType && giftCardType.optionalMessages) {
          let optionalMessages = giftCardType.optionalMessages.map(msgKey => enums.presetMessages.optional[msgKey]);
          presetMessages = enums.presetMessages.global.concat(optionalMessages);
        }
        presetMessages = presetMessages.map(message => message.replace(/\${tradeId}/g, trade.tradeId));

        const total = trade.payments.reduce((sum, value) => sum + value, 0);
        const split3Trades = ['a', 'b', 'c'];
        trade = {
          ...trade,
          date: trade.date && new Date(trade.date).toLocaleString(),
          presetMessages,
          total,
          splitId2: ((trade.splitId || 0) % 2) + 1,
          splitId3: split3Trades[(trade.splitId || 0) % 3],
          receivedMessagesCount: trade.messages.filter(msg => !msg.mine).length,
          photosCount: trade.images.length,
          paymentsCount: trade.payments.length,
          unreadMessages: 0,
        };

        trade.iconClasses = {
          cards: '',
          photos: '',
          messages: '',
        };

        // photoVerified
        // cardDataVerified


        if(expanded[trade.tradeId]){
          saveViewedData(trade);
        }

        const savedViewedData = getSavedViewData(trade.tradeId);

        if(trade.photoVerified) {
          trade.iconClasses.photos = 'complete';
        }else if(trade.photosCount === 0){
          trade.iconClasses.photos = 'empty';
        }else if(trade.photosCount > savedViewedData.photosCount){
          trade.iconClasses.photos = 'new';
        }

        if(trade.cardDataVerified) {
          trade.iconClasses.cards = 'complete';
        }else if(trade.paymentsCount === 0){
          trade.iconClasses.cards = 'empty';
        }else if(trade.paymentsCount > savedViewedData.paymentsCount){
          trade.iconClasses.cards = 'new';
        }

        if(trade.receivedMessagesCount === 0){
          trade.iconClasses.messages = 'empty';
        }else if(trade.receivedMessagesCount > savedViewedData.receivedMessagesCount){
          trade.iconClasses.messages = 'new';
          trade.unreadMessages = trade.receivedMessagesCount - savedViewedData.receivedMessagesCount;
        }


        if (trade.token) {
          const minutesLeft = ((new Date(trade.tokenExpiration) - new Date()) / (1000 * 60));
          return {
            ...trade,
            tokenUrl: '/missing',
            minutesLeft: Math.ceil(minutesLeft),
          };
        }
        return trade;
      });
  }
);

export const getGroupedTrades = createSelector(
  getTrades,
  state => state.trades.filtersFormState.data,
  state => state.auth.type,
  ownProps,
  (trades, filters, userType, context) => {

    if(!trades){
      return null;
    }

    const isManager = userType === 'admin' || userType === 'manager';

    const groups = {
      default: [],
      help: [],
      flagged: [],
      blocked: [],
    };
    if(context === 'open'){
      trades.forEach(trade=> {

        let filterOut = false;
        if(filters && filters.split){
          filterOut = filters.split !== trade.splitId2.toString() && filters.split !== trade.splitId3;
        }

        if(trade.helpRequested){
          if(!filterOut || isManager){
            groups.help.push(trade);
          }
        }else if(trade.flagged) {
          if(!filterOut || isManager){
            groups.flagged.push(trade);
          }
        }else if(trade.trade_status === 'Dispute open' || trade.isBlacklisted) {
          if(!filterOut || isManager){
            groups.blocked.push(trade);
          }
        }else {
          if(!filterOut){
            groups.default.push(trade);
          }
        }
      });
    }else{
      groups.default = trades;
    }

    return groups;
  },
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.selectors.js